// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3OB4E","header":"MessagesList_header__3yVx7","chat":"MessagesList_chat__ibzYx"};